
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/components/AppIcon/AppIcon.scss.css.virtualfile';
        module.exports = {"container":"_container_6va6m_7","withDot":"_withDot_6va6m_10","icon":"_icon_6va6m_23","withBorder":"_withBorder_6va6m_27"};